import gql from "graphql-tag"

const query = gql`
  query LocationFilterTags {
    dealLocationFilterTags {
      uuid
      name
      isNational
    }
  }
`

export const toString = query.loc.source.body

export default query
